import React from 'react';
import PropTypes from 'prop-types';

class SimpleCellFormatter extends React.PureComponent {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object, PropTypes.bool])
  };

  render() {
    const { value } = this.props;
    return <div>{value}</div>;
  }
}

export default SimpleCellFormatter;
